import { ShoppingPrefsPayload } from '@services/user-shopping-preferences-service';

export const makeShoppingPrefsPayload = (preferences: ShoppingPrefsPayload) => {
  let payload = '';

  if (preferences) {
    payload = JSON.stringify(preferences);
  }

  return payload;
};
